(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comfo-product"] && !Shopify.designMode) return;
  try {
    
function initComfo(scope=document){scope.querySelectorAll('[data-comfo-page]').forEach(page=>{if(page.dataset.initialized)return;page.dataset.initialized='true';const main=page.querySelector('[data-comfo-main]'),thumbs=[...page.querySelectorAll('[data-comfo-image]')];let index=0;const show=n=>{index=(n+thumbs.length)%thumbs.length;const b=thumbs[index];main.src=b.dataset.comfoImage;main.alt=b.dataset.comfoAlt;thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===index)));page.querySelector('[data-comfo-count]').textContent=(index+1)+' / '+thumbs.length;};thumbs.forEach((b,i)=>b.addEventListener('click',()=>show(i)));page.querySelector('[data-comfo-prev]').addEventListener('click',()=>show(index-1));page.querySelector('[data-comfo-next]').addEventListener('click',()=>show(index+1));main.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();main.click();}});const dialog=page.querySelector('[data-comfo-lightbox]');main.addEventListener('click',()=>{const i=dialog.querySelector('img');i.src=main.src;i.alt=main.alt;dialog.showModal();});dialog.querySelector('button').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});const qty=page.querySelector('[name=quantity]');const clampQty=()=>{qty.value=Math.max(1,Math.floor(Number(qty.value)||1));};page.querySelector('[data-comfo-minus]').addEventListener('click',()=>{clampQty();qty.value=Math.max(1,Number(qty.value)-1);});page.querySelector('[data-comfo-plus]').addEventListener('click',()=>{clampQty();qty.value=Number(qty.value)+1;});qty.addEventListener('change',clampQty);const select=page.querySelector('[data-comfo-variant]');if(select){select.addEventListener('change',()=>{const o=select.selectedOptions[0],buy=page.querySelector('[data-comfo-buy]');page.querySelectorAll('[data-comfo-price]').forEach(p=>p.textContent=o.dataset.price);buy.disabled=o.dataset.available!=='true';buy.textContent=buy.disabled?buy.dataset.sold:buy.dataset.add;const u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState(null,'',u);});}});}initComfo();document.addEventListener('shopify:section:load',e=>initComfo(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
